$(document).ready(function () {
  ("use strict");

  // Datepicker
  $('input.date').datepicker({
    format: "dd-mm-yyyy",
    language: "ca",
    weekStart: 1
  });

  // Tooltips
  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })

});